import React from 'react'

import {
  Button, Icon as LibIcon, FullScreen, Close,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func, number, bool } from 'prop-types'

import Icon from 'Pods/Shared/Icon/Icon'

function Header({
  fullScreenGalleryIndex,
  activeIndex,
  totalCount,
  fullScreenGallery,
  triggerFullScreenGallery,
}) {
  return (
    <div className="gallery-area-header__header">
      <div className="gallery-area-header__header-left">
        {!fullScreenGallery && totalCount > 0 && (
          <Button
            actionType="button"
            icon={<LibIcon svgComponent={FullScreen} color="light" />}
            type="ghost"
            variant="only-icon"
            onClick={triggerFullScreenGallery}
            color="white-100"
            customClass="gallery-area-header__fullscreen-button"
            aria-label="Fullscreen"
          />
        )}
        {totalCount > 0 && (
          <p className="gallery-area-header__images-count cgt-legacy-heading-h6 cgt-legacy-color-white-100">
            {fullScreenGallery ? `${fullScreenGalleryIndex + 1}/${totalCount}` : `${activeIndex + 1}/${totalCount}`}
          </p>
        )}
      </div>
      {totalCount > 1 && (
        <div className="gallery-area-header__nav-info">
          Use{' '}
          <span className="gallery-area-header__nav-info-key">
            <Icon type={['far', 'arrow-left']} notSpaced />
          </span>
          <span className="gallery-area-header__nav-info-key">
            <Icon type={['far', 'arrow-right']} notSpaced />
          </span>
          {' '}to navigate. Press
          <span className="gallery-area-header__nav-info-key">esc</span>{' '}
          to quit
        </div>
      )}
      {fullScreenGallery && (
        <Button
          actionType="button"
          icon={<Close width="20" height="20" />}
          type="ghost"
          variant="only-icon"
          onClick={triggerFullScreenGallery}
          color="white-100"
          customClass="gallery-area-header__button"
          aria-label="Close"
        />
      )}
    </div>
  )
}

Header.propTypes = {
  fullScreenGalleryIndex: number.isRequired,
  activeIndex: number.isRequired,
  totalCount: number.isRequired,
  fullScreenGallery: bool.isRequired,
  triggerFullScreenGallery: func.isRequired,
}

export default Header
